import { ChangeEventHandler, useRef, useState } from 'react';

export function useSearchInput() {
  const inputRef = useRef<HTMLInputElement>(null);
  const [search, setSearch] = useState('');

  const handleChange: ChangeEventHandler<HTMLInputElement> = event => {
    setSearch(event.target.value);
  };

  const clear = () => setSearch('');

  return { inputRef, search, handleChange, clear };
}
